export const gMapsScript = 'https://maps.googleapis.com/maps/api/js?key=';
export const gApiKey = 'AIzaSyBlfK9pyop6d7R6gmkzU8GkN9FX0GgSB8I';
export const gLibraries = {
  places: 'places',
  geometry: 'geometry',
};
